import $ from "jquery";

const shopFilter = () => {
    const init = () => {
        execute();
    };

    const objectToParam = (paramsObj) => {
        return Object.keys(paramsObj)
            .map(
                (key) =>
                    encodeURIComponent(key) +
                    "=" +
                    encodeURIComponent(paramsObj[key]),
            )
            .join("&");
    };

    const execute = () => {
        const el = {
            main: ".js-shop-filter",
            input: ".js-shop-filter input:checked",
        };
        if ($(el.main).length === 0) return;

        $(document).on("submit", el.main, function (e) {
            e.preventDefault();
            const currentUrl = $(this).data("current_url");

            const paramObj = {};
            $(el.input).each(function () {
                const name = $(this).attr("name");
                const value = $(this).val();

                if (!paramObj[name]) {
                    paramObj[name] = [];
                }

                paramObj[name].push(value);
            });

            const params = objectToParam(paramObj);

            window.location.href = `${currentUrl}?${params}`;
        });
    };
    init();
};

try {
    shopFilter();
} catch (error) {
    console.error("shopFilter", error);
}
